import React from "react";
import PrivacyV10Document from "./documents/PrivacyV10Document";

const BiztingPrivacyPolicyV10Page = () => {
    return <PrivacyV10Document />;
};

export default BiztingPrivacyPolicyV10Page;
